export default "__VITE_ASSET__2ce81d9a__"